import {useData} from "vike-react/useData";
import {ApiLivestreamData, ApiStreamerDescription} from "#/src/definitions/ApiDefinitions";
import {ResponsiveCardMasonry} from "#/src/pages/live/@id/ResponsiveCardMasonry";
import {Sort} from "#/src/utils/sort-utils";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import DOMPurify from "isomorphic-dompurify";

export function StreamerDescriptions() {
  const {data: livestreamData} = useData() as DataWrapped<ApiLivestreamData>;
  if (livestreamData.streamer.description.length === 0) {
    return <></>
  }

  function render() {
    return <section className="channel-info my-4" id="channel">
      <div className="container-xxl">
        <div className="row">
          <div className="col-xl-12">
            <h2 className="basic-headline mb-4">Opis kanału</h2>
            {renderCards()}
          </div>
        </div>
      </div>
    </section>
  }

  function renderCards() {
    const masonryData = Sort.byDisplayPriority(livestreamData.streamer.description).map((description: ApiStreamerDescription) => {
        return <div key={description.id} className="channel-column">
          {description.isImageSet && <img alt={description.title} src={Attachments.getUrl(AttachmentNamespace.DESCRIPTION_CARD, description)}/>}
          {description.title && <p className={"text-white"}>{description.title}</p>}
          {description.description && <p className="channel-column-text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(description.description)}}/>}
        </div>
      });
    return <ResponsiveCardMasonry cards={masonryData}/>
  }

  return render();
}